module.exports = __webpack_public_path__ + "img/firmshift-logo-blue.5b401bae.svg";